module.exports = __webpack_public_path__ + "img/quest_icon_0042_arrow.7117494c.png";